import { CampaignCallStatus } from '@shared/constants/recipient-status.constants';

export const CallStatuses = {
  ...CampaignCallStatus,
  all: 'all',
};

export const CallEndedReasons = {
  'agent-detected-end-call-phrase': 'agent-detected-end-call-phrase',
  'agent-join-timed-out': 'agent-join-timed-out',
  'agent-forwarded-call': 'agent-forwarded-call',
  'transfer-failed': 'transfer-failed',
  'customer-busy': 'customer-busy',
  'customer-unavailable': 'customer-unavailable',
  'customer-ended-call': 'customer-ended-call',
  'manually-canceled': 'manually-canceled',
  'internal-error': 'internal-error',
  'unknown-reason': 'unknown-reason',
  'error-sip-telephony-provider-failed-to-connect-call':
    'error-sip-telephony-provider-failed-to-connect-call',
  'error-sip-provider-declined': 'error-sip-provider-declined',
  'usage-limits-exceeded': 'usage-limits-exceeded',
  'concurrent-limit-reached': 'concurrent-limit-reached',
  'participant-removed': 'participant-removed',
  'customer-did-not-join': 'customer-did-not-join',
  'worker-crashed': 'worker-crashed',
  'stale-timeout': 'stale-timeout',
  all: 'all',
};

export const SentimentIndicators = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
  all: 'all',
};
